export const asyncMessagingTags = {
  REGISTRATION_HOME_PAGE_LOAD_LIVEPERSON: data => {
    return {
      event: 'async-messaging-liveperson',
      data,
    };
  },
};
